export const INITIAL_STATE = {
    tags: []
}